import { lazy, Suspense } from "react";
import { useLocale } from "use-intl";
import Loader from "../../AnimatedLoader";
import { SwipeableDrawer } from "../../SwipeableDrawer";

const ArabicTerms = lazy(() => import("./ArabicTerms"));
const EnglishTerms = lazy(() => import("./EnglishTerms"));

const MoreDetailsDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const locale = useLocale();

  return (
    <SwipeableDrawer
      onClose={onClose}
      open={open}
      hasFullHeight
      heightOffset={100}
    >
      {open ? (
        <div className="prose-sm">
          <Suspense fallback={<Loader icon="users" />}>
            {locale === "ar" ? <ArabicTerms /> : <EnglishTerms />}
          </Suspense>
        </div>
      ) : null}
    </SwipeableDrawer>
  );
};

export default MoreDetailsDrawer;
